<template>
	<div class="layout">
		<div class="tool-box">
			<div class="tool-box-title">
				<img src="/static/imgs/shangpintiaocan.png" class="jxyd-imgicon" />
				商品信息
			</div>
			<button class="jxyd-button jxyd-primary" @click="dataSubmit">保存</button>
			<button class="jxyd-button" @click="emptyForm">重置</button>
		</div>
		<div>
			<div class="content-item">
				<div class="modal-title">
					<div class="layout-title-left">
						<img src="/static/imgs/jibenxinxi.png" class="jxyd-imgicon" />
						基本信息
					</div>
					<div class="layout-title-right">
					</div>
				</div>
				<table id="baseinfo-table">
					<tr>
						<td class="key">
							商品条码
						</td>
						<td style="width:35%;">
							<input v-model="formItem.code" type="text" placeholder="使用扫码枪扫描或手动输入，留空自动生成"
								class="baseinfo-input" icon="md-qr-scanner" />
						</td>
						<td class="key">
							商品名称
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td style="width:35%;">
							<input v-model="formItem.name" type="text" placeholder="请输入商品名称" class="baseinfo-input" />
						</td>
					</tr>
					<tr>
						<td class="key">
							商品种类
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td style="text-align: left;padding: 5px;">
							<selectTree v-model="formItem.type" :treeData="commodityTypeData" :border='false'>
							</selectTree>
						</td>
						<td class="key">
							计量单位
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td style="padding: 5px;">
							<div class="content-left-right-split">
								<div style="width: 75%;" v-if="!formItem.isMultiMetering">
									<SelectConfig :sc_type='commodityUnitPid' :sc_data.sync="formItem.unit"
										:sc_multiple="false" sc_size="small"></SelectConfig>
								</div>
								<div style="width: 75%;" v-else>
									<Input :value="getUnitDisplayContent" @on-focus="unitConfigModal = true;" />
								</div>
								<div>
									<Checkbox v-model="formItem.isMultiMetering" @on-change="isMultiMeteringChange">多单位
									</Checkbox>
								</div>
							</div>
						</td>
					</tr>
					<tr>
						<td class="key">
							商品规格
						</td>
						<td style="text-align: left;">
							<div class="content-left-right-split">
								<div style="width: 70%;">
									<input v-model="formItem.format" @input="formatInput" type="text"
										placeholder="请输入商品规格" class="baseinfo-input" />
								</div>
								<div class="format-btn" @click="setFormatDrawer = true;">
									<label>多规格</label>
									<Icon type="ios-arrow-forward" size='18' />
								</div>
							</div>
						</td>
						<td class="key">
							是否启用
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td>
							<i-Switch v-model="formItem.isUse" />
						</td>
					</tr>
					<tr>
						<td class="key">
							启用批次
						</td>
						<td>
							<i-Switch v-model="formItem.enableBatch"  @on-change="enableBatchChange"/>
						</td>
						<td class="key">
							库存预警
						</td>
						<td style="text-align: left;">
							<div class="content-left-right-split">
								<input class="baseinfo-input" placeholder="输入库存预警" v-model="formItem.stockPrompt"
									@input="checkNumberValue(formItem,'stockPrompt',formItem.stockPrompt)" />
							</div>
						</td>
					</tr>
					<tr>
						<td class="key">
							备注
						</td>
						<td style="text-align: left;" colspan="3">
							<input type="textarea" v-model="formItem.note" placeholder="请输入备注" class="baseinfo-input">
						</td>
					</tr>
				</table>
			</div>

			<div class="content-item">
				<div class="modal-title" style="border-bottom: 1px solid #e8eaec;">
					<div class="layout-title-left">
						<img src="/static/imgs/tupianwenjian.png" class="jxyd-imgicon" />
						商品图片
					</div>
					<div class="layout-title-right">
					</div>
				</div>
				<div style="padding:15px 10px;">
					<Upload :show-upload-list="false" action="/file/file/UploadImg" :max-size="2048"
						:format="['jpg','jpeg','png','gif']" :on-format-error="upLoadFormatError"
						:on-exceeded-size="uploadFileSizeError" :before-upload="upLoadBefore"
						:on-success="upLoadFileSuccess" :on-error="upLoadFileError">
						<Button type="dashed" title="添加图片">
							<Icon type="ios-images" size='18' />
							添加图片
						</Button>
						<span style="padding-left:20px;">
							注：上传文件大小限制为2M；格式支持图片类型文件；最多支持上传3个图片
						</span>
					</Upload>
					<ul class="imgFile">
						<li v-for="item in formItem.imgFile">
							<Icon type="md-trash" size='18' class="icon-item-dele" @click.stop="deleFile(item.url)" />
							<div class="img-box" @click="previewSkuImages(formItem.imgFile)">
								<Avatar id="head-img-ava" shape="square" :src="item.url"
									style="width:100%;height:100%;" />
							</div>
						</li>
					</ul>
				</div>
			</div>
			<div class="content-item">
				<div class="modal-title" style="border-bottom: 1px solid #e8eaec;">
					<div class="layout-title-left">
						<img src="/static/imgs/shangpintiaocan.png" class="jxyd-imgicon" />
						单品管理
					</div>
					<div class="layout-title-right">
						<a href="javascript:void(0)" @click="batchSetCode" class='jxyd-a'>
							生成条码
						</a>
					</div>
				</div>
				<div style="padding:15px 10px;">
					<Table stripe :columns="skuFormatTableColumns" :data="getSkuData" :span-method="handleSpan" border>
						<!-- 图片列插槽 - 使用图片上传预览子组件 -->
						<template slot-scope="{ row }" slot="imgFiles">
							<div style="text-align: center; padding: 8px;">
								<!-- 显示第一张图片 -->
								<div v-if="row.imgFiles && row.imgFiles.length > 0">
									<img :src="row.imgFiles[0].url"
										style="width: 80px; height: 80px; object-fit: cover; border-radius: 4px; cursor: pointer;"
										@click="previewSkuImages(row.imgFiles)" />
									<!-- 图片数量提示 -->
									<div v-if="row.imgFiles.length > 1" style="margin-top: 4px;">
										<Tag color="blue">
											<Icon type="md-images" /> {{ row.imgFiles.length }}张
										</Tag>
									</div>
								</div>

								<!-- 上传组件 -->
								<Upload v-else ref="upload" :show-upload-list="false"
									:before-upload="(file) => skuGroupBeforeUpload(file, row)"
									:format="['jpg','jpeg','png','gif']" :max-size="2048" :multiple="true"
									:on-success="(response, file, fileList) => skuGroupUploadSuccess(response, file, fileList, row)"
									action="/file/file/UploadImg">
									<Button type="dashed" style="width: 100px;height: 100px;">
										<Icon type="md-add" size='30' />
									</Button>
								</Upload>

								<!-- 已有图片时的上传按钮 -->
								<div v-if="row.imgFiles && row.imgFiles.length > 0 && row.imgFiles.length < 3"
									style="margin-top: 8px;">
									<Upload :show-upload-list="false"
										:before-upload="(file) => skuGroupBeforeUpload(file, row)"
										:format="['jpg','jpeg','png','gif']" :max-size="2048"
										action="/file/file/UploadImg"
										:on-success="(response, file, fileList) => skuGroupUploadSuccess(response, file, fileList, row)">
										<Button type="primary" size="small" icon="md-add">
											继续添加({{ row.imgFiles.length }}/3)
										</Button>
									</Upload>
								</div>

								<!-- 删除按钮 -->
								<div v-if="row.imgFiles && row.imgFiles.length > 0" style="margin-top: 8px;">
									<Button class="jxyd-borderbtn jxyd-searchbtn" size="small" icon="ios-trash"
										@click="removeAllImages(row._index)">
										清空图片
									</Button>
								</div>
							</div>
						</template>
					</Table>
				</div>
			</div>
			<div class="content-item">
				<div class="modal-title" style="border-bottom: 1px solid #e8eaec;">
					<div class="layout-title-left">
						<img src="/static/imgs/tupianwenjian.png" class="jxyd-imgicon" />
						价格管理
					</div>
					<div class="layout-title-right">
						单品不同定价
						<i-Switch v-model="formItem.isDifferentPricing" />
					</div>
				</div>
				<div style="padding:15px 10px;">
					<Form inline v-if='!formItem.isDifferentPricing'>
						<FormItem label="采购价" style="width: 32%;">
							<Input type="text" icon="logo-yen"
								@input="checkNumberValue(formItem,'intoPrice',formItem.intoPrice)"
								v-model="formItem.intoPrice" placeholder="请输入采购价">
							</Input>
						</FormItem>
						<FormItem label="批发价" style="width: 32.5%;">
							<Input type="text" icon="logo-yen"
								@input="checkNumberValue(formItem,'wholesalePricePrice',formItem.wholesalePricePrice)"
								v-model="formItem.wholesalePricePrice" placeholder="请输入批发价">
							</Input>
						</FormItem>
						<FormItem label="零售价" style="width: 32.5%;">
							<Input type="text" icon="logo-yen"
								@input="checkNumberValue(formItem,'retailPrice',formItem.retailPrice)"
								v-model="formItem.retailPrice" placeholder="请输入零售价">
							</Input>
						</FormItem>
					</Form>
					<div v-else>
						<Table stripe :columns="skuPriceTableColumns" :data="getSkuData" :span-method="handleSpan2"
							border />
					</div>
				</div>
			</div>
			<div class="content-item" v-show="this.formItem.id <=0">
				<div class="modal-title" style="border-bottom: 1px solid #e8eaec;">
					<div class="layout-title-left">
						<img src="/static/imgs/tupianwenjian.png" class="jxyd-imgicon" />
						期初库存
					</div>
					<div class="layout-title-right">
					</div>
				</div>
				<div style="padding:15px 10px;">
					<Table stripe :columns="skuPreStockTableColumns" :data="preStockData" border />
				</div>
			</div>
		</div>
		<Modal v-model="unitConfigModal" draggable sticky scrollable>
			<p slot="header" style="text-align:left">
				<Icon type="ios-create-outline" size='18' />
				<span> 多单位设置</span>
			</p>
			<div class="unit-modal-content">
				<div class="cu-form-group">
					<div class="cu-form-title">
						基本单位:
					</div>
					<SelectConfig :sc_type='commodityUnitPid' :sc_data.sync="formItem.unit" :sc_multiple="false"
						sc_size="small" @change="baseUnitChange"></SelectConfig>
				</div>
				<div class="cu-form-group" v-for="(item,index) in formItem.extraUnits" :key="index"
					v-show="item.unit != formItem.unit">
					<div class="cu-form-title">
						辅助单位:
					</div>
					<SelectConfig :sc_type='commodityUnitPid' :sc_data.sync="formItem.extraUnits[index].unit"
						:sc_multiple="false" sc_size="small" style="width: 160px;"
						@change="(val)=> extraUnitChange(val,index)"></SelectConfig>
					<div style="padding: 10px;">=</div>
					<div style="width: 100px;">
						<input
							@input="checkNumberValue(formItem.extraUnits[index],'conversionRate',formItem.extraUnits[index].conversionRate)"
							style="border: 1px solid #dcdee2 !important;"
							v-model="formItem.extraUnits[index].conversionRate" placeholder="输入换算数量" />
					</div>
					<div style="margin-left: 15px;">
						<Icon type="md-remove-circle" size='25' color="#ff6a7f" @click="deleUnit(item)" />
					</div>
				</div>
				<div class="cu-form-group">
					<Button type="dashed" Icon='md-add' style="width: 253px;margin-left: 79px;"
						@click="addUnit">添加单位</Button>
				</div>
			</div>
			<div slot="footer">
				<button class="jxyd-button jxyd-primary" @click="unitConfigModal = false;">关闭</button>
				<button class="jxyd-button" @click="saveUnit">保存</button>
			</div>
		</Modal>
		<Modal v-model="setStockModal" draggable sticky scrollable>
			<p slot="header" style="text-align:left">
				<Icon type="ios-create-outline" size='18' />
				<span>设置库存</span>
			</p>
			<div class="unit-modal-content">
				<Table stripe :columns="setStockTableColumns" :height="400"
					:data="preStockData[setStockIndex] ? preStockData[setStockIndex].detail:[]" border />
			</div>
			<div slot="footer">
				<button class="jxyd-button jxyd-primary" @click="setStockModal = false;">关闭</button>
				<button class="jxyd-button" @click="setStockModal = false;">保存</button>
			</div>
		</Modal>
		<MultiFormatSetting :show-drawer="setFormatDrawer" :commodityId="formItem.id"
			@drawer-change="multiFormatSettingChange" ref="formatSetting" @up-commodity-format="upCommodityFormat" />

		<!-- 使用封装的图片预览子组件 -->
		<ImagePreview ref="imagePreview" :images="previewImagesList" :visible.sync="previewVisible"
			:initial-index="currentImageIndex" @change="onPreviewImageChange" />
	</div>
</template>

<script>
	import request from '@/utils/request'
	import formatNum from '@/utils/formatNum'
	import selectTree from '@/components/selectTree'
	import SelectConfig from '@/components/SelectConfig'
	import MultiFormatSetting from '@/components/MultiFormatSetting'
	import ImagePreview from '@/components/ImagePreview' // 导入图片预览子组件

	export default {
		name: 'commodityfunc',
		components: {
			selectTree,
			SelectConfig,
			MultiFormatSetting,
			ImagePreview // 注册图片预览子组件
		},
		computed: {
			getUnitDisplayContent() {
				var returnStr = this.formItem.unit;
				this.formItem.extraUnits.forEach(item => {
					if (item.unit != this.formItem.unit) {
						returnStr += `/(${item.unit}=${item.conversionRate}${this.formItem.unit})`;
					}
				})
				return returnStr;
			},
			getSkuData() {
				let array = [];
				this.formItem.commodityPriceTypeGroups.forEach((item, index) => {
					item.commodityPriceTypes.forEach((item2, index2) => {
						array.push({
							_index: index, // 用于标识行索引
							index: array.length + 1,
							code: item2.code,
							groupIndex: index,
							priceTypeIndex: index2,
							imgFiles: item.imgFiles ? item.imgFiles : [],
							groupName: item.groupName,
							priceType: item2.priceType,
							intoPrice: item2.intoPrice,
							wholesalePricePrice: item2.wholesalePricePrice,
							retailPrice: item2.retailPrice,
						})
					});
				});
				this.$nextTick(() => {
					this.calculateSpan();
				});
				return array;
			}
		},
		data() {
			return {
				commodityTypeData: [],
				formItem: {
					id: 0,
					code: '',
					name: '',
					imgFile: [],
					type: '',
					unit: '',
					format: '',
					intoPrice: '',
					wholesalePricePrice: '',
					retailPrice: '',
					enableBatch: false,
					stockPrompt: '',
					isMultiMetering: false,
					extraUnits: [],
					isDifferentPricing: false,
					stock: 0,
					commodityInventorys: [],
					commodityPriceTypeGroups: [],
					note: '',
					creator: 0,
					isUse: true
				},
				commodityTypePid: 'spzl',
				commodityUnitPid: 'spdw',
				unitConfigModal: false,
				setFormatDrawer: false,
				editCodeIndex: -1,
				skuFormatTableColumns: [{
						title: '序号',
						key: 'index',
						width: 80,
						align: 'center',
						render: (h, params) => {
							return h('span', params.index + 1);
						}
					},
					{
						title: '图片',
						key: 'imgFiles',
						width: 200,
						align: 'center',
						slot: 'imgFiles' // 使用自定义插槽
					},
					{
						title: '群组',
						key: 'groupName',
						width: 180,
						align: 'center'
					},
					{
						title: '条码',
						key: 'code',
						width: 230,
						align: 'center',
						render: (h, params) => {
							if (this.editCodeIndex == params.index) {
								return h('Input', {
									attrs: {
										'value': params.row.code ? params.row.code : '',
										'icon': "md-qr-scanner",
										'placeholder': "使用扫码枪或手动输入",
										'maxlength': 13
									},
									on: {
										'on-blur': (val) => {
											this.editCodeIndex = -1;
										},
										'input': (val2) => {
											let val = val2.replace(
												/(^\s*)|(\s*$)/g, "")
											if (!val) {
												this.formItem.commodityPriceTypeGroups[params.row
													.groupIndex].commodityPriceTypes[params.row
													.priceTypeIndex].code = '';
												return;
											}
											var reg = /[^\d]/g // 只允许数字，不允许小数点和其他字符

											// 移除非数字字符
											val = val.replace(reg, "")

											// 如果值为负数，设为空
											if (val < 0) {
												val = ''
											}
											this.$nextTick(() => {
												this.formItem.commodityPriceTypeGroups[params
													.row.groupIndex].commodityPriceTypes[
													params.row.priceTypeIndex].code = val;
											})
										}
									}
								});
							} else {
								return h('span', params.row.code ? params.row.code : '无');
							}
						}
					},
					{
						title: '规格',
						key: 'priceType',
						align: 'left'
					},
					{
						title: '操作',
						key: 'action',
						width: 200,
						align: 'center',
						fixed: 'right',
						render: (h, params) => {
							var btnArr = [];
							btnArr.push(h('a', {
								class: 'jxyd-a',
								style: {
									'margin-right': '5px'
								},
								on: {
									click: (val) => {
										this.removePriceType(params.row.groupIndex, params.row
											.priceTypeIndex);
									}
								}
							}, '删除'));

							btnArr.push(h('a', {
								class: 'jxyd-a',
								style: {
									'margin-right': '5px'
								},
								on: {
									click: (val) => {
										this.editCodeIndex = params.index;
									}
								}
							}, '编辑条码'));
							return btnArr;
						}
					}
				],
				skuPriceTableColumns: [{
						title: '序号',
						key: 'index',
						width: 80,
						align: 'center',
						render: (h, params) => {
							return h('span', params.index + 1);
						}
					},
					{
						title: '群组',
						key: 'groupName',
						width: 180,
						align: 'center'
					},
					{
						title: '规格',
						key: 'priceType',
						width: 200,
						align: 'left'
					},
					{
						title: '采购价',
						key: 'intoPrice',
						width: 230,
						align: 'left',
						render: (h, params) => {
							return h('Input', {
								attrs: {
									'value': params.row.intoPrice ? params.row.intoPrice : '',
									'icon': "logo-yen",
									'placeholder': "请输入采购价"
								},
								on: {
									'input': (val2) => this.checkNumberValue(this.formItem
										.commodityPriceTypeGroups[
											params.row.groupIndex].commodityPriceTypes[params.row
											.priceTypeIndex], 'intoPrice', val2)
								}
							});
						}
					},
					{
						title: '批发价',
						key: 'wholesalePricePrice',
						width: 230,
						align: 'left',
						render: (h, params) => {
							return h('Input', {
								attrs: {
									'value': params.row.wholesalePricePrice ? params.row
										.wholesalePricePrice : '',
									'icon': "logo-yen",
									'placeholder': "请输入批发价"
								},
								on: {
									'input': (val2) => this.checkNumberValue(this.formItem
										.commodityPriceTypeGroups[
											params.row.groupIndex].commodityPriceTypes[params.row
											.priceTypeIndex], 'wholesalePricePrice', val2)
								}
							});
						}
					},
					{
						title: '零售价',
						key: 'retailPrice',
						width: 230,
						align: 'left',
						render: (h, params) => {
							return h('Input', {
								attrs: {
									'value': params.row.retailPrice ? params.row.retailPrice : '',
									'icon': "logo-yen",
									'placeholder': "请输入零售价"
								},
								on: {
									'input': (val2) => this.checkNumberValue(this.formItem
										.commodityPriceTypeGroups[
											params.row.groupIndex].commodityPriceTypes[params.row
											.priceTypeIndex], 'retailPrice', val2)
								}
							});
						}
					},
					{
						title: '操作',
						key: 'action',
						width: 200,
						align: 'center',
						fixed: 'right',
						render: (h, params) => {
							var btnArr = [];
							btnArr.push(h('a', {
								class: 'jxyd-a',
								style: {
									'margin-right': '5px'
								},
								on: {
									click: (val) => {
										// 获取当前修改的数据
										const currentData = this.formItem.commodityPriceTypeGroups[
												params.row.groupIndex]
											.commodityPriceTypes[params.row.priceTypeIndex];

										// 提取需要同步的字段
										const fieldsToSync = {};
										if (currentData.intoPrice !== undefined) fieldsToSync
											.intoPrice = currentData.intoPrice;
										if (currentData.wholesalePricePrice !== undefined)
											fieldsToSync.wholesalePricePrice = currentData
											.wholesalePricePrice;
										if (currentData.retailPrice !== undefined) fieldsToSync
											.retailPrice = currentData.retailPrice;

										// 如果没有需要同步的字段，直接返回
										if (Object.keys(fieldsToSync).length === 0) return;

										// 同步到所有其他项
										this.formItem.commodityPriceTypeGroups.forEach((group,
											groupIndex) => {
											group.commodityPriceTypes.forEach((priceType,
												priceTypeIndex) => {
												// 跳过当前修改的项（根据需求决定是否保留这个逻辑）
												// 原代码注释掉了这个判断，所以这里也跳过
												// if (groupIndex === params.row.groupIndex && priceTypeIndex === params.row.priceTypeIndex) return;

												// 更新字段
												Object.assign(priceType,
													fieldsToSync);
											});
										});
									}
								}
							}, '批量设置'));
							return btnArr;
						}
					}
				],
				// 图片预览相关 - 简化后的变量
				previewVisible: false,
				previewImagesList: [],
				currentImageIndex: 0,
				// 存储合并信息的数组
				spanArr: [],
				preStockData: [{
					guid: 1,
					depotId: '',
					stock: '',
					sellByDate: [],
					detail: []
				}],
				depotList: [],
				skuPreStockTableColumns: [{
						title: '行号',
						key: 'guid',
						width: 80
					},
					{
						title: '仓库',
						key: 'type',
						render: (h, params) => {
							return [h('Select', {
									props: {
										transfer: true,
										value: params.row.depotId
									},
									style: {
										width: '100%'
									},
									on: {
										input: (event) => {
											this.preStockData[params.index].depotId = event;
										}
									},
								},
								this.depotList.map(function(depot) {
									return h('Option', {
										props: {
											value: depot.id,
											key: depot.depotName
										}
									}, depot.depotName);
								})
							)];
						}
					},
					{
						title: '库存',
						key: 'stock',
						render: (h, params) => {
							return [h('InputNumber', {
								props: {
									min: 0,
									value: this.getTotalStock(params.row.detail)
								},
								style: {
									'width': '100%'
								},
								on: {
									'on-focus': (e) => {
										if (!params.row.depotId) {
											this.$Notice.error({
												title: '错误提示',
												duration: 3,
												desc: "还未选择仓库！"
											});
											return;
										}
										this.formItem.commodityPriceTypeGroups.forEach(item => {
											item.commodityPriceTypes.forEach(item2 => {
												if (this.preStockData[params.index]
													.detail.findIndex(m => m
														.commodityPriceType == item
														.groupName + ',' + item2
														.priceType) < 0) {
													this.preStockData[params.index]
														.detail.push({
															commodityPriceType: item
																.groupName +
																',' + item2
																.priceType,
															stock: 0
														});
												}
											});
										});
										this.setStockIndex = params.index;
										this.setStockModal = true;
									}
								}
							})]
						}
					},
					{
						title: '保质期',
						key: 'stock',
						render: (h, params) => {
							return [h('DatePicker', {
								props: {
									type: 'daterange',
									transfer: true,
									value: params.row.sellByDate,
									disabled: this.formItem.enableBatch ? false : true
								},
								style: {
									'width': '100%'
								},
								on: {
									'on-change': (e) => {
										this.preStockData[params.index].sellByDate = e;
									}
								}
							})]
						}
					},
					{
						title: '操作',
						key: 'action',
						align: 'center',
						render: (h, params) => {
							var btnArr = [];
							btnArr.push(h('Icon', {
								style: {
									cursor: 'pointer',
									'margin-right': '10px'
								},
								props: {
									type: 'md-add-circle',
									size: 24,
									color: '#ff6a7f'
								},
								on: {
									click: (e) => {
										this.preStockData.push({
											guid: this.preStockData.length + 1,
											depotId: '',
											stock: '',
											sellByDate: [],
											detail: []
										});
									}
								}
							}));
							btnArr.push(h('Icon', {
								style: {
									cursor: 'pointer',
								},
								props: {
									type: 'ios-remove-circle-outline',
									size: 24
								},
								on: {
									click: (e) => {
										if (this.preStockData.length > 1) {
											this.preStockData.splice(params.index, 1);
											for (var i = 0; i < this.preStockData.length; i++) {
												this.preStockData[i].guid = i + 1;
											}
										}
									}
								}
							}));
							return btnArr;
						}
					}
				],
				setStockModal: false,
				setStockIndex: -1,
				setStockTableColumns: [{
						title: '规格',
						key: 'commodityPriceType',
						align: 'left'
					},
					{
						title: '库存',
						key: 'stock',
						align: 'left',
						render: (h, params) => {
							return h('InputNumber', {
								attrs: {
									min: 0,
									'value': params.row.stock ? params.row.stock : 0,
									'placeholder': "请输入库存数量"
								},
								style: {
									width: '100%'
								},
								on: {
									'input': (val2) => {
										this.preStockData[this.setStockIndex].detail[params.index]
											.stock = val2;
									}
								}
							});
						}
					},
					{
						title: '操作',
						key: 'action',
						width: 200,
						align: 'center',
						fixed: 'right',
						render: (h, params) => {
							var btnArr = [];
							btnArr.push(h('a', {
								class: 'jxyd-a',
								style: {
									'margin-right': '5px'
								},
								on: {
									click: (val) => {
										let stock = this.preStockData[this.setStockIndex].detail[
												params
												.index]
											.stock;
										this.preStockData[this.setStockIndex].detail.forEach((
											item, index) => {
											if (index != params.index) {
												item.stock = stock;
											}
										})
									}
								}
							}, '批量设置'));
							return btnArr;
						}
					}
				]
			}
		},
		methods: {
			initDepotData() {
				let self = this;
				request.get('/api/Depot/GetDepotList').then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取仓库数据失败：" + response.errorMsg
						});
						return;
					}
					self.depotList = response.data;
				}).catch(function(error) {})
			},
			async removePriceType(index, index2) {
				try {
					if (!await this.doCheckRemove(this.formItem.commodityPriceTypeGroups[index].commodityPriceTypes[
							index2].priceType)) {
						this.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "该商品规格还有库存，不可移除"
						});
						return;
					}
					this.formItem.commodityPriceTypeGroups[index].commodityPriceTypes.splice(index2, 1);
					if (this.formItem.commodityPriceTypeGroups[index].commodityPriceTypes.length <= 0) {
						this.formItem.commodityPriceTypeGroups.splice(index, 1);
					}
				} catch (error) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "删除单品失败"
					});
				}
			},
			async doCheckRemove(param) {
				let result1 = false;
				try {
					let result = await request.get('/api/Commodity/GetStockByFormat', {
						params: {
							commodityId: this.formItem.id,
							format: param
						}
					});
					if (result.state != 1) {
						this.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "通过商品规格获取库存失败"
						});
						return;
					}
					result1 = result.data <= 0;
				} catch (error) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "通过商品规格获取库存失败"
					});
				}
				return result1;
			},
			multiFormatSettingChange(value) {
				this.setFormatDrawer = value;
			},
			upCommodityFormat(value) {
				if (value) {
					let formatData = this.formatData(value);
					this.optimizedSync(formatData);
					this.formatCommodityFormat(value);
				}
			},
			formatCommodityFormat(data) {
				this.formItem.format = '';
				data.forEach((item) => {
					if (this.formItem.format) {
						this.formItem.format += ',';
					}
					let arrayStr = '';
					item.items.forEach((item2) => {
						if (arrayStr) {
							arrayStr += '|';
						}
						arrayStr += item2;
					});
					this.formItem.format += arrayStr;
				});
			},
			formatData(data) {
				if (data.length > 0) {
					// 提取第一个属性（颜色）的值
					const colors = data[0].items;

					// 提取其他属性（尺码、型号、材质）的值
					const otherProps = data.slice(1).map(prop => prop.items);

					// 计算其他属性的笛卡尔积
					const otherCombinations = otherProps.reduce((acc, current) => {
						return acc.flatMap(combo =>
							current.map(item => [...combo, item])
						);
					}, [
						[]
					]);

					// 生成最终结果数组
					return colors.map(color => {
						// 为每个颜色生成组合
						const combinations = otherCombinations.map(combo => [color, ...combo].join('+'));

						return {
							key: color,
							value: combinations
						};
					});
				}
				return [];
			},
			// 高效合并函数
			optimizedSync(data1) {
				// 创建Map用于快速查找 
				const data2Map = new Map();
				const valueSets = new Map();
				// 初始化Map和Set 
				this.formItem.commodityPriceTypeGroups.forEach(item => {
					data2Map.set(item.groupName, item);
					const set = new Set(item.commodityPriceTypes.map(pt => pt.priceType));
					valueSets.set(item.groupName, set);
				});
				// 同步数据 
				data1.forEach(item1 => {
					const groupName = item1.key;
					const values = item1.value;
					if (data2Map.has(groupName)) {
						// 组已存在，添加缺失的值 
						const set = valueSets.get(groupName);
						const group = data2Map.get(groupName);
						values.forEach(value => {
							if (!set.has(value)) {
								group.commodityPriceTypes.push({
									priceType: value,
									code: '',
									retailPrice: 0,
									intoPrice: 0,
									wholesalePricePrice: 0
								});
								set.add(value);
							}
						});
					} else {
						// 添加新组 
						const newGroup = {
							groupName: groupName,
							imgFiles: [],
							commodityPriceTypes: values.map(value => ({
								priceType: value,
								code:'',
								retailPrice: 0,
								intoPrice: 0,
								wholesalePricePrice: 0
							}))
						};
						this.formItem.commodityPriceTypeGroups.push(newGroup);
						data2Map.set(groupName, newGroup);
						valueSets.set(groupName, new Set(values));
					}
				});
			},
			initCommodityType() {
				let self = this;
				request.get('/api/DataDictionary/GetTreeOfDataDictionary', {
					params: {
						code: self.commodityTypePid
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "初始化界面失败"
						});
						console.log("获取导航树数据失败：" + response.errorMsg)
						return;
					}
					self.commodityTypeData = [];
					self.formatTypeData(self.commodityTypeData, response.data);
				}).catch(function(error) {})
			},
			formatTypeData(dataArray, array) {
				for (var i = 0; i < array.length; i++) {
					dataArray.push({
						id: array[i].id,
						title: array[i].title,
						value: array[i].path,
						expand: array[i].expand,
						selected: array[i].selected,
						note: array[i].note,
						path: array[i].path,
						children: []
					});
					if (array[i].children && array[i].children.length > 0) {
						this.formatTypeData(dataArray[i].children, array[i].children);
					}
				}
			},
			dataSubmit() {
				if (this.check()) {
					let self = this;
					request.post('/api/Commodity/EditCommodity', self.formItem).then(
						function(response) {
							if (response.state == 0) {
								self.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: '保存失败:' + response.errorMsg
								});
								return;
							}

							self.$Notice.success({
								title: '正确提示',
								duration: 3,
								desc: '保存成功!'
							});
							self.emptyForm();
						}).catch(function(error) {})
				}
			},
			formatInput(val) {
				if (this.formItem.format) {
					this.formItem.commodityPriceTypeGroups = [{
						groupName: '默认组',
						imgFiles: [],
						commodityPriceTypes: [{
							priceType: this.formItem.format
						}]
					}];
					//self.formItem.commodityInventorys = [];
					//self.formItem.stock = '';
					//self.emptyPrice();
				}
			},
			check() {
				if (!this.formItem.name) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '请输入商品名!'
					});
					return false
				}

				if (!this.formItem.type) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '请输入商品种类!'
					});
					return false
				}

				if (!this.formItem.unit) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '请选择计量单位!'
					});
					return false
				}

				if (this.formItem.commodityPriceTypeGroups.length <= 0) {
					this.formItem.commodityPriceTypeGroups = [{
						groupName: '默认组',
						imgFiles: [],
						commodityPriceTypes: [{
							priceType: '默认规格'
						}]
					}]
				}
				if (!this.formItem.intoPrice) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '请正确输入采购价格!'
					});
					return false
				}

				if (!this.formItem.retailPrice) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '请正确输入零售价格!'
					});
					return false
				}

				if (!this.formItem.wholesalePricePrice) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '请正确输入批发价格!'
					});
					return false
				}

				if (!this.formItem.isDifferentPricing) {
					this.formItem.commodityPriceTypeGroups.forEach(item => {
						item.commodityPriceTypes.forEach(item2 => {
							item2.intoPrice = this.formItem.intoPrice;
							item2.retailPrice = this.formItem.retailPrice;
							item2.wholesalePricePrice = this.formItem.wholesalePricePrice;
						})
					})
				}

				if (!this.formItem.stockPrompt) {
					this.formItem.stockPrompt = 0
				}
				this.formItem.commodityInventorys = [];
				if (this.preStockData.length > 0) {
					for (let i = 0; i < this.preStockData.length; i++) {
						for (let n = 0; n < this.preStockData[i].detail.length; n++) {
							if (this.preStockData[i].detail[n].stock > 0) {
								if (!this.preStockData[i].depotId) {
									this.$Notice.error({
										title: '错误提示',
										duration: 3,
										desc: '期初库存中未正确选择仓库!'
									});
									return;
								}
								if (this.formItem.enableBatch && (!this.preStockData[i].sellByDate || this.preStockData[i]
										.sellByDate.length < 2)) {
									this.$Notice.error({
										title: '错误提示',
										duration: 3,
										desc: '期初库存中未正确选择保质期!'
									});
									return;
								}

								this.formItem.commodityInventorys.push({
									depotId: this.preStockData[i].depotId,
									depotName: '',
									commodityPriceType: this.preStockData[i].detail[n].commodityPriceType,
									sellByDate: this.preStockData[i].detail[n].sellByDate,
									batchCode: null,
									stock: this.preStockData[i].detail[n].stock
								});
							}
						}
					}
				}

				return true
			},
			enableBatchChange(val){
				if(val){
					let array = this.formItem.commodityInventorys.filter(m=>m.batchCode == null && m.stock > 0);
					if(array.length>0){
						this.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: '还存在非批次库存，不可启用!'
						});
						this.$nextTick(()=>{
							this.formItem.enableBatch = false;
						})
						return;
					}
				}else{
					let array = this.formItem.commodityInventorys.filter(m=>m.batchCode && m.stock > 0);
					if(array.length>0){
						this.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: '还存在批次库存，不可禁用!'
						});
						this.$nextTick(()=>{
							this.formItem.enableBatch = true;
						})
						return;
					}
				}
			},
			emptyForm() {
				this.formItem.id = 0;
				this.formItem.code = '';
				this.formItem.name = '';
				this.formItem.imgFile = [];
				this.formItem.type = '';
				this.formItem.format = '';
				this.formItem.stock = 0;
				this.formItem.unit = '';
				this.formItem.isDifferentPricing = false;
				this.formItem.retailPrice = '';
				this.formItem.wholesalePricePrice = '';
				this.formItem.intoPrice = '';
				this.formItem.enableBatch = false;
				this.formItem.stockPrompt = '';
				this.formItem.isMultiMetering = false;
				this.formItem.extraUnits = [];
				this.formItem.commodityInventorys = [];
				this.formItem.commodityPriceTypeGroups = [];
				this.formItem.note = '';
				this.formItem.creator = 0;
				this.formItem.isUse = true;
			},
			isMultiMeteringChange(value) {
				this.unitConfigModal = value;
				if (!value) {
					this.formItem.extraUnits = [];
				}
			},
			deleUnit(index) {
				this.formItem.extraUnits.splice(index, 1);
			},
			addUnit() {
				this.formItem.extraUnits.push({
					rowNum: this.formItem.extraUnits.length + 1,
					unit: '',
					conversionRate: '',
					conversionIntoPrice: 0,
					conversionOutPrice: 0,
					conversionStock: 0,
					note: '',
					creator: parseInt(localStorage.getItem("userId"))
				});
			},
			extraUnitChange(value, index) {
				if (this.formItem.unit == value) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '与基本单位重复！'
					});
					this.$nextTick(() => {
						this.formItem.extraUnits[index].unit = '';
					})
					return;
				}
				this.formItem.extraUnits.forEach((item, index2) => {
					if (index2 != index) {
						if (item.unit == value) {
							this.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: '与其它辅助单位重复！'
							});
							this.$nextTick(() => {
								this.formItem.extraUnits[index].unit = '';
							})
							return;
						}
					}
				})
			},
			baseUnitChange(value) {
				this.$nextTick(() => {
					this.formItem.extraUnits.forEach((item, index) => {
						if (item.unit == value) {
							this.formItem.extraUnits[index].unit = '';
						}
					});
				})
			},
			saveUnit() {
				for (let i = this.formItem.extraUnits.length - 1; i >= 0; i--) {
					if (!this.formItem.extraUnits[i].unit) {
						this.formItem.extraUnits.splice(i, 1);
						continue;
					}
					if (this.formItem.extraUnits[i].unit && !this.formItem.extraUnits[i].conversionRate) {
						this.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: this.formItem.extraUnits[i].unit + '的换算数量未输入！'
						});
						return;
					}
				}
				this.unitConfigModal = false;
			},
			upLoadBefore(file) {
				if (this.formItem.imgFile.length >= 3) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '最多上传3个文件!'
					});
					return false;
				}
			},
			upLoadFileSuccess(response, file, fileList) {
				if (response.state == 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '上传失败：' + response.errorMsg + '!'
					});
					return;
				}
				this.formItem.imgFile.push({
					name: this.formItem.name,
					url: response.data[0],
					creator: parseInt(localStorage.getItem("userId"))
				});
			},
			upLoadFileError(error, file, fileList) {
				this.$Notice.error({
					title: '错误提示',
					duration: 3,
					desc: '上传失败：' + error + '!'
				});
			},
			upLoadFormatError(file) {
				this.$Notice.error({
					title: '错误提示',
					duration: 3,
					desc: '上传失败：请上传jpg、jpeg、png、gif格式图片！'
				});
			},
			uploadFileSizeError(file) {
				this.$Notice.error({
					title: '错误提示',
					duration: 3,
					desc: '上传失败：不可选择超过2M大小文件！'
				});
			},
			calculateSpan() {
				this.spanArr = [];
				let pos = 0;

				for (let i = 0; i < this.getSkuData.length; i++) {
					if (i === 0) {
						this.spanArr.push(1);
						pos = 0;
						continue;
					}

					if (this.getSkuData[i].groupName === this.getSkuData[i - 1].groupName) {
						this.spanArr[pos] += 1;
						this.spanArr.push(0);
					} else {
						this.spanArr.push(1);
						pos = i;
					}
				}
			},
			handleSpan({
				rowIndex,
				columnIndex
			}) {
				// 对于每一列都要返回合并配置

				// 1. 图片列 (columnIndex = 1)
				if (columnIndex === 1) {
					const rowspan = this.spanArr[rowIndex];
					const colspan = 1;

					// 如果rowspan为0，表示该单元格应该被隐藏
					if (rowspan === 0) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}

					// 否则返回正常的合并配置
					return {
						rowspan: rowspan,
						colspan: colspan
					};
				}

				// 2. 分组列 (columnIndex = 2)
				if (columnIndex === 2) {
					const rowspan = this.spanArr[rowIndex];
					const colspan = 1;

					if (rowspan === 0) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}

					return {
						rowspan: rowspan,
						colspan: colspan
					};
				}

				// 3. 其他列（序号和SKU名称）不需要合并，返回默认配置
				return {
					rowspan: 1,
					colspan: 1
				};
			},
			handleSpan2({
				rowIndex,
				columnIndex
			}) {
				// 对于每一列都要返回合并配置

				// 2. 分组列 (columnIndex = 2)
				if (columnIndex === 1) {
					const rowspan = this.spanArr[rowIndex];
					const colspan = 1;

					if (rowspan === 0) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}

					return {
						rowspan: rowspan,
						colspan: colspan
					};
				}

				// 3. 其他列（序号和SKU名称）不需要合并，返回默认配置
				return {
					rowspan: 1,
					colspan: 1
				};
			},
			/**
			 * 上传前的处理
			 */
			skuGroupBeforeUpload(file, row) {
				// 获取当前行的图片数组
				const currentImgs = this.formItem.commodityPriceTypeGroups[row.groupIndex].imgFiles || [];

				// 检查是否已达到3张
				if (currentImgs.length >= 3) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "最多只能上传3张图片！"
					});
					return false;
				}

				// 检查文件类型
				const validTypes = ['image/jpeg', 'image/png', 'image/gif'];
				if (!validTypes.includes(file.type)) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "只支持 JPG、PNG、GIF 格式的图片！"
					});
					return false;
				}

				// 检查文件大小
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "图片大小不能超过 2MB！"
					});
					return false;
				}

				return true;
			},

			/**
			 * 上传成功处理
			 */
			skuGroupUploadSuccess(response, file, fileList, row) {
				if (response.state == 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '上传失败：' + response.errorMsg + '!'
					});
					return;
				}
				this.formItem.commodityPriceTypeGroups[row.groupIndex].imgFiles.push({
					name: this.formItem.commodityPriceTypeGroups[row.groupIndex].groupName,
					url: response.data[0],
					creator: parseInt(localStorage.getItem("userId"))
				});
			},

			/**
			 * 预览SKU图片 - 简化版本，使用子组件
			 */
			previewSkuImages(images) {
				if (!images || images.length === 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "暂无图片"
					});
					return;
				}

				this.previewImagesList = images;
				this.currentImageIndex = 0;
				this.previewVisible = true;
			},

			/**
			 * 图片切换事件
			 */
			onPreviewImageChange(index, image) {
				this.currentImageIndex = index;
			},

			/**
			 * 清空所有图片
			 */
			removeAllImages(rowIndex) {
				this.$Modal.confirm({
					title: '确认清空',
					content: '确定要清空所有图片吗？',
					onOk: () => {
						this.formItem.commodityPriceTypeGroups[rowIndex].imgFiles = [];
						this.$Message.success('图片已清空');
					}
				});
			},

			/**
			 * 删除文件
			 */
			deleFile(url) {
				this.formItem.imgFile = this.formItem.imgFile.filter(item => item.url !== url);
			},
			// 在UniApp中生成20位纯数字随机数的通用方法
			generate20DigitRandomNumber() {
				let digits = [];

				// 生成第一位（1-9）
				let firstDigit = Math.floor(Math.random() * 9) + 1;
				digits.push(firstDigit);

				// 生成其余19位（0-9）
				for (let i = 1; i < 13; i++) {
					let digit = Math.floor(Math.random() * 10);
					digits.push(digit);
				}

				return digits.join('');
			},
			batchSetCode() {
				this.formItem.commodityPriceTypeGroups.forEach(item => {
					item.commodityPriceTypes.forEach(item2 => {
						if (!item2.code) {
							item2.code = this.generate20DigitRandomNumber();
						}
					});
				});
			},
			checkNumberValue(data, prop, val2) {
				if (val2) {
					data[prop] = val2;
				}
				let val = data[prop].replace(/(^\s*)|(\s*$)/g, "")
				if (!val) {
					data[prop] = '';
					return;
				}
				var reg = /[^\d.]/g

				// 只能是数字和小数点，不能是其它输入
				val = val.replace(reg, "")
				// // 保证第一位只能是数字，不能是点
				val = val.replace(/^\./g, "");
				// // 小数只能出现1位
				val = val.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
				if (val < 0) {
					val = '';
				}
				this.$nextTick(() => {
					data[prop] = val;
				})
			},
			formatBatchPriceRange(data) {
				// 收集所有价格
				let retailPrices = [];
				let intoPrices = [];
				let wholesalePricePrices = [];
				// 遍历每个组，提取所有价格
				data.forEach(group => {
					for (let i = 0; i < group.commodityPriceTypes.length; i++) {
						if (group.commodityPriceTypes[i].retailPrice != null) {
							retailPrices.push(group.commodityPriceTypes[i].retailPrice);
						}
						if (group.commodityPriceTypes[i].intoPrice != null) {
							intoPrices.push(group.commodityPriceTypes[i].intoPrice);
						}
						if (group.commodityPriceTypes[i].wholesalePricePrice != null) {
							wholesalePricePrices.push(group.commodityPriceTypes[i].wholesalePricePrice);
						}
					}
				});
				// 找出所有价格中的最小值和最大值
				let result = {
					retailPrice: '',
					intoPrice: '',
					wholesalePricePrice: ''
				};
				if (retailPrices.length > 0) {
					const minRetailPrice = Math.min(...retailPrices);
					const maxRetailPrice = Math.max(...retailPrices);
					if (minRetailPrice == 0 && maxRetailPrice == 0) {} else {
						result.retailPrice = minRetailPrice === maxRetailPrice ?
							minRetailPrice.toString() : `${minRetailPrice}～${maxRetailPrice}`;
					}
				}
				if (intoPrices.length > 0) {
					const minIntoPrice = Math.min(...intoPrices);
					const maxIntoPrice = Math.max(...intoPrices);
					if (minIntoPrice == 0 && maxIntoPrice == 0) {} else {
						result.intoPrice = minIntoPrice === maxIntoPrice ?
							minIntoPrice.toString() : `${minIntoPrice}～${maxIntoPrice}`;
					}
				}
				if (wholesalePricePrices.length > 0) {
					const minWholesalePricePrice = Math.min(...wholesalePricePrices);
					const maxWholesalePricePrice = Math.max(...wholesalePricePrices);
					if (minWholesalePricePrice == 0 && maxWholesalePricePrice == 0) {} else {
						result.wholesalePricePrice = minWholesalePricePrice === maxWholesalePricePrice ?
							minWholesalePricePrice.toString() : `${minWholesalePricePrice}～${maxWholesalePricePrice}`;
					}
				}
				// 返回格式化后的组数据
				return result;
			},
			getTotalStock(array) {
				let stock = 0;
				array.forEach(item => {
					stock += item.stock;
				})
				return stock;
			},
			async getCommodity(id) {
				let self = this;
				return await request.get('/api/Commodity/GetCommodity', {
					params: {
						id: id
					}
				});
			}
		},
		watch: {
			'formItem.commodityPriceTypeGroups': {
				deep: true,
				handler(array) {
					try {
						let priceData = this.formatBatchPriceRange(this.formItem
							.commodityPriceTypeGroups);
						this.formItem.retailPrice = priceData.retailPrice;
						this.formItem.intoPrice = priceData.intoPrice;
						this.formItem.wholesalePricePrice = priceData.wholesalePricePrice;
					} catch (error) {
						this.formItem.retailPrice = 0;
						this.formItem.intoPrice = '';
						this.formItem.wholesalePricePrice = '';
					}

				}
			}
		},
		created: function() {
			this.initCommodityType();
			this.initDepotData();
		},
		async activated() {
			this.emptyForm();
			if (this.$route.query.commodityId) {
				let response = await this.getCommodity(this.$route.query.commodityId);
				if (response.state == 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "获取商品数据失败：" + response.errorMsg
					});
				} else {
					this.formItem = response.data;
				}
			}
		}
	}
</script>

<style scoped>
	.layout {
		border-radius: 8px;
	}

	.field-table {
		width: 100%;
		padding: 20px 20px 0px 20px;
		border-radius: 5px;
	}

	.field-group {
		background-color: #fff;
		margin-top: 10px;
		overflow: auto;
	}

	.tool-box {
		padding: 10px;
		background-color: #fff;
		overflow: hidden;
		border-left: 5px solid rgb(255, 106, 127);
		margin-bottom: 10px;
	}

	.tool-box Button {
		margin-right: 10px;
		float: right;
	}

	.tool-box-title {
		float: left;
		font-size: 16px;
		color: black;
		height: 30px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	#baseinfo-table {
		width: 100%;
		background-color: #fff;
		color: #666;
		border-collapse: collapse;
	}

	#baseinfo-table td,
	#baseinfo-table th {
		position: relative;
		padding: 9px 15px;
		min-height: 20px;
		line-height: 20px;
		font-size: 14px;
		border-width: 1px;
		border-style: solid;
		border-color: #e6e6e6;
	}


	.baseinfo-input {
		border: none;
		outline: none;
		height: 15px;
		padding-left: 0px;
		width: 100%;
	}

	.content-item {
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}

	.content-item+.content-item {

		margin-top: 10px;
	}

	#commodityInfo {
		margin-top: 10px;
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}

	#voucher-bottomBar {
		background-color: antiquewhite;
		padding: 7.5px 22px 0px 10px;
		box-shadow: 0 -1px 6px rgba(0, 0, 0, .15);
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: auto !important;
		padding: 12px 30px !important;
	}

	.imgFile {
		margin-top: 15px;
		overflow: hidden;
	}

	.imgFile li {
		margin-right: 15px;
		width: 100px;
		height: 100px;
		float: left;
		position: relative;
	}

	.icon-item-dele {
		position: absolute;
		right: 0px;
		top: 0px;
		z-index: 1;
	}

	.icon-item-dele:hover {
		transform: scale(1.3);
	}

	.modal-title {
		overflow: hidden;
		padding-bottom: 10px;
		font-size: 16px;
	}

	.layout-title-left {
		float: left;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.layout-title-right {
		float: right;
	}

	.unit-modal-content {
		width: 100%;
		padding: 10px;
		background-color: #fff;
		border-radius: 5px;
		height: 420px;
		overflow: auto;
	}

	/deep/ .cu-form-group input {
		border: none !important;
	}

	.format-btn {
		overflow: hidden;
		color: rgb(255, 106, 127);
	}

	.format-btn :hover {
		text-decoration: underline;
	}

	/deep/ .ivu-checkbox-wrapper {
		margin: 0px;
	}

	/* 表格样式 */
	.ivu-table-cell {
		padding: 12px;
	}

	.ivu-table-wrapper {
		position: relative;
		z-index: 1;
	}

	.text-center {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100%;
	}

	.img-box {
		width: 100%;
		height: 100%;
		cursor: pointer;
	}
</style>